export const navigation = {
  philosophy: "Filosofie",
  services: "Diensten",
  training: "Training",
  credentials: "Referenties",
  clientele: "Klanten",
  approach: "Aanpak",
  contact: "Contact"
};

export const hero = {
  title: "Elite Medische Beveiliging",
  subtitle: "Voor Vermogende Particulieren",
  description: "Het leveren van ongeëvenaarde medische noodtraining en responsdiensten aan ultra-vermogende families, privé-landgoederen, luxe jachten en exclusieve bedrijfsomgevingen wereldwijd.",
  cta: "Plan Consultatie"
};

export const philosophy = {
  title: "Onze Filosofie",
  subtitle: "Excellentie Zonder Compromis",
  description: "Wij geloven dat medische noodgevallen onmiddellijke, deskundige interventie vereisen. Onze filosofie draait om het bieden van de hoogste kwaliteit medische training en noodhulpdiensten, speciaal afgestemd op veeleisende klanten die alleen het beste eisen."
};

export const services = {
  title: "Kerndiensten",
  subtitle: "Uitgebreide Medische Oplossingen",
  cpr_title: "Geavanceerde CPR/AED Training",
  cpr_description: "Professionele certificeringscursussen ontworpen voor huishoudelijk personeel, jachtbemanningen en beveiligingspersoneel.",
  emergency_title: "Noodrespons",
  emergency_description: "24/7 snelle respons medische diensten met elite paramedicus teams.",
  consultation_title: "Medische Consultatie",
  consultation_description: "Deskundige medische adviesservices voor hoog-risico omgevingen en activiteiten."
};

export const footer = {
  copyright: "© 2024 U First Doctors. Alle rechten voorbehouden.",
  phone: "Telefoon",
  email: "E-mail",
  address: "Adres"
};